/* Thrift Threads — email-capture popup controller.
   Triggers on delay / scroll depth / exit-intent, once per cooldown, never after
   a visitor subscribes. After a native {% form 'customer' %} submit the page reloads;
   we reopen the popup in its server-rendered success (or error) state, using a
   sessionStorage flag so a footer-newsletter submit does not falsely trigger it.
   Exposes window.ttPopup = { open, close } for manual/testing use. */
(function () {
  var SEEN_KEY = 'ttPopupSeen';        // localStorage: last dismissal timestamp
  var SUB_KEY = 'ttPopupSubscribed';   // localStorage: '1' once subscribed
  var PENDING_KEY = 'ttPopupPending';  // sessionStorage: popup form was submitted
  var COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000; // re-show after 7 days
  var DELAY_MS = 8000;
  var SCROLL_PCT = 0.35;

  function lget(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lset(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var popup = document.getElementById('tt-popup');
    if (!popup) return;

    var form = popup.querySelector('#tt-popup-form');
    var serverSuccess = !!popup.querySelector('[data-tt-success]');
    var serverError = !!popup.querySelector('.tt-popup__error');
    var pending = sget(PENDING_KEY);
    var opened = false;
    var timer = null;

    function open() {
      if (opened) return;
      opened = true;
      teardownTriggers();
      popup.hidden = false;
      void popup.offsetWidth; // reflow so the transition runs
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tt-popup-open');
      document.addEventListener('keydown', onKey);
      var focusTarget = popup.querySelector('.tt-popup__close');
      if (focusTarget) { try { focusTarget.focus(); } catch (e) {} }
    }
    function close() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tt-popup-open');
      document.removeEventListener('keydown', onKey);
      lset(SEEN_KEY, String(Date.now()));
      setTimeout(function () { popup.hidden = true; }, 340);
    }
    function onKey(e) { if (e.key === 'Escape' || e.keyCode === 27) close(); }

    var closers = popup.querySelectorAll('[data-tt-popup-close]');
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', close);

    window.ttPopup = { open: open, close: close };

    // Tap-to-copy the discount code shown in the success state.
    var copyBtn = popup.querySelector('[data-tt-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-code') || '';
        var hint = copyBtn.querySelector('[data-tt-copy-hint]');
        function done() {
          copyBtn.classList.add('is-copied');
          if (hint) hint.textContent = 'Copied!';
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          try {
            var t = document.createElement('textarea');
            t.value = code; t.setAttribute('readonly', '');
            t.style.position = 'absolute'; t.style.left = '-9999px';
            document.body.appendChild(t); t.select();
            document.execCommand('copy'); document.body.removeChild(t);
          } catch (e) {}
          done();
        }
      });
    }

    // Flag popup-originated submits so we can tell them apart from the footer form.
    if (form) form.addEventListener('submit', function () { sset(PENDING_KEY, '1'); });

    // Reopen after a popup submit round-trip.
    if (serverSuccess && pending) { lset(SUB_KEY, '1'); sset(PENDING_KEY, ''); open(); return; }
    if (serverError && pending) { sset(PENDING_KEY, ''); open(); return; }

    if (lget(SUB_KEY) === '1') return; // already a subscriber

    // Never auto-show on the cart or account pages (checkout is not themeable).
    var main = document.getElementById('MainContent');
    var tmpl = (main && main.getAttribute('data-template')) || '';
    if (tmpl.indexOf('cart') === 0 || tmpl.indexOf('customers') === 0) return;

    var seen = parseInt(lget(SEEN_KEY) || '0', 10);
    if (seen && (Date.now() - seen) < COOLDOWN_MS) return;

    timer = setTimeout(open, DELAY_MS);
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('mouseout', onExit);

    function onScroll() {
      var h = document.documentElement;
      var scrolled = h.scrollTop || document.body.scrollTop || 0;
      var max = (h.scrollHeight - h.clientHeight) || 1;
      if (scrolled / max >= SCROLL_PCT) open();
    }
    function onExit(e) { if (e.clientY <= 0) open(); }
    function teardownTriggers() {
      if (timer) clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onExit);
    }
  });
})();
